import { Guid } from 'Lib/Guid';
import { map } from 'rxjs/operators';
import webApi from '../../../Lib/WebApi';
import { callApi } from '../../Helpers/rxjsHelpers';

export const callApiGetPrototypeReadingsForTimeSequence = (worksheetId: Guid, timeSequenceId: Guid) => {
  return callApi(webApi.soil.psdHydrometerTests.prototypeReadings.get({ worksheetId, timeSequenceId })).pipe(
    map((response) => response.Body)
  );
};
